import { parsePhotoDimensions } from './dimensionsCheck';
import { ICloudinaryResponse } from './uploadFile';

// Extract public id from the URL. Its always after /image/upload/ and before the file extension (so just look for the next '.')
const PUBLIC_ID = /\/image\/upload\/([^\.]+)/;

export async function mapS3PhotoToCloudinaryResponse(
  s3UploadUrl: string,
  uploadedFile: File,
): Promise<ICloudinaryResponse> {
  const publicId = s3UploadUrl.match(PUBLIC_ID)?.[1];

  const timestamp = Math.floor(Date.now() / 1000);

  const { height, width } = await parsePhotoDimensions(uploadedFile);

  // The default of 'jpg' aligns with the default extension that Reverb::Image::Upload sets in core
  const format = uploadedFile.name.split('.').pop().toLowerCase() || 'jpg';

  return {
    public_id: publicId,
    format,
    resource_type: 'image',
    original_filename: uploadedFile.name,
    version: timestamp,
    height,
    width,
  };
}
